import { render, staticRenderFns } from "./menu-actions.vue?vue&type=template&id=cc8a1068&"
import script from "./menu-actions.vue?vue&type=script&lang=js&"
export * from "./menu-actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports